import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ImageDetail } from '@bookinglab/govbook-ui';
import { NavLink } from '@bookinglab/govbook-ui/layout';
import { HeaderComponent as GbHeaderComponent } from '@bookinglab/govbook-ui/layout';
import { DatastoreService } from '../../services';

@Component({
	selector: 'app-header',
	standalone: true,
	imports: [CommonModule, GbHeaderComponent],
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
	constructor(private datastoreService: DatastoreService) {}

	login() {
		window.open(
			'https://chapter.registrars.staging.bookinglab.co.uk/havering-staging/37002/access',
			'_blank'
		);
	}

	isAdmin() {
		return this.datastoreService.adminJourney;
	}
	imageDetail: ImageDetail = {
		alt: 'Langtons House, Hornchurch, Est. 1760',
		src: 'assets/images/langtons_logo.svg',
	};

	// Nav retargeted to the Langtons House site (langtons-house.vercel.app), which is a
	// WIP/demo microsite -- it has no "Citizenship ceremonies" page, so that item was
	// swapped for "Fees and charges" (a real, prominent page there) instead.
	navigation: NavLink[] = [
		{
			text: 'House and gardens',
			url: 'https://langtons-house.vercel.app/house-gardens.html',
		},
		{
			text: 'Marriages and civil partnerships',
			url: 'https://langtons-house.vercel.app/marriages-civil-partnerships.html',
		},
		{
			text: 'Give notice',
			url: 'https://langtons-house.vercel.app/marriages-civil-partnerships.html#legal',
		},
		{
			text: 'Approved venues',
			url: 'https://langtons-house.vercel.app/marriages-civil-partnerships.html#venues',
		},
		{
			text: 'Fees and charges',
			url: 'https://langtons-house.vercel.app/fees-charges.html',
		},
	];

	search(term: string) {
		const formatted = term.trim().replace(/\s+/g, '+');
		const url = `https://www.havering.gov.uk/site-search/results/?q=${formatted}`;
		window.location.href = url;
	}
}
